const POSITIONS = {
  CENTER: 'center',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOP_RIGHT: 'top-right',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  TOP_LEFT: 'top-left',
  LEFT_BOTTOM: 'left-bottom',
  LEFT_TOP: 'left-top',
  RIGHT_BOTTOM: 'right-bottom',
  RIGHT_TOP: 'right-top',
  AUTO: 'auto',
  AUTO_START: 'auto-start',
  AUTO_END: 'auto-end',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
};

const componentVariants = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  GREY: 'grey',
  DARK: 'dark',
  LIGHT: 'light',
  WHITE: 'white',
  PLAIN: 'plain',
});

const buttonVariants = Object.freeze({
  ...componentVariants,
  SIMPLE: 'simple',
});

const iconSizes = Object.freeze({
  '2XS': '2xs',
  XS: 'xs',
  SM: 'sm',
  LG: 'lg',
  XL: 'xl',
  '2XL': '2xl',
  '1X': '1x',
  '2X': '2x',
  '3X': '3x',
  '4X': '4x',
  '5X': '5x',
  '6X': '6x',
  '7X': '7x',
  '8X': '8x',
  '9X': '9x',
  '10X': '10x',
});

const iconFlipOptions = Object.freeze({
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  BOTH: 'both',
});

const iconPullOptions = Object.freeze({
  LEFT: POSITIONS.LEFT,
  RIGHT: POSITIONS.RIGHT,
});

const inputTypes = Object.freeze({
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  COLOR: 'color',
  DATE: 'date',
  DATETIME: 'datetime',
  EMAIL: 'email',
  FILE: 'file',
  HIDDEN: 'hidden',
  IMAGE: 'image',
  MONTH: 'month',
  NUMBER: 'number',
  PASSWORD: 'password',
  RADIO: 'radio',
  RANGE: 'range',
  RESET: 'reset',
  SEARCH: 'search',
  SUBMIT: 'submit',
  TEL: 'tel',
  TEXT: 'text',
  TIME: 'time',
  URL: 'url',
  WEEK: 'week',
});

const buttonTypes = Object.freeze({
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
});

const menuAlignOptions = Object.freeze({
  BOTTOM_RIGHT: POSITIONS.BOTTOM_RIGHT,
  BOTTOM_LEFT: POSITIONS.BOTTOM_LEFT,
  TOP_RIGHT: POSITIONS.TOP_RIGHT,
  TOP_LEFT: POSITIONS.TOP_LEFT,
  LEFT_BOTTOM: POSITIONS.LEFT_BOTTOM,
  LEFT_TOP: POSITIONS.LEFT_TOP,
  RIGHT_BOTTOM: POSITIONS.RIGHT_BOTTOM,
  RIGHT_TOP: POSITIONS.RIGHT_TOP,
});

const tableCellAlignOptions = Object.freeze({
  LEFT: POSITIONS.LEFT,
  CENTER: POSITIONS.CENTER,
  RIGHT: POSITIONS.RIGHT,
});

const tooltipPositionOptions = Object.freeze({
  TOP: POSITIONS.TOP,
  TOP_START: POSITIONS.TOP_START,
  TOP_END: POSITIONS.TOP_END,
  BOTTOM: POSITIONS.BOTTOM,
  BOTTOM_START: POSITIONS.BOTTOM_START,
  BOTTOM_END: POSITIONS.BOTTOM_END,
  LEFT: POSITIONS.LEFT,
  LEFT_START: POSITIONS.LEFT_START,
  LEFT_END: POSITIONS.LEFT_END,
  RIGHT: POSITIONS.RIGHT,
  RIGHT_START: POSITIONS.RIGHT_START,
  RIGHT_END: POSITIONS.RIGHT_END,
  AUTO: POSITIONS.AUTO,
  AUTO_START: POSITIONS.AUTO_START,
  AUTO_END: POSITIONS.AUTO_END,
});

const tooltipMultilineOptions = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
});

const indicatorPositionOptions = Object.freeze({
  TOP_RIGHT: POSITIONS.TOP_RIGHT,
  TOP_LEFT: POSITIONS.TOP_LEFT,
  BOTTOM_RIGHT: POSITIONS.BOTTOM_RIGHT,
  BOTTOM_LEFT: POSITIONS.BOTTOM_LEFT,
  CENTER: POSITIONS.CENTER,
});

const navigationTags = Object.freeze({
  A: 'a',
  ROUTER_LINK: 'router-link',
  NUXT_LINK: 'nuxt-link',
});

const notificationPositionOptions = Object.freeze({
  TOP_RIGHT: POSITIONS.TOP_RIGHT,
  BOTTOM_RIGHT: POSITIONS.BOTTOM_RIGHT,
  BOTTOM_LEFT: POSITIONS.BOTTOM_LEFT,
  TOP_LEFT: POSITIONS.TOP_LEFT,
});

const flagCodes = Object.freeze({
  AD: 'ad',
  AE: 'ae',
  AF: 'af',
  AG: 'ag',
  AI: 'ai',
  AL: 'al',
  AM: 'am',
  AO: 'ao',
  AQ: 'aq',
  AR: 'ar',
  AS: 'as',
  AT: 'at',
  AU: 'au',
  AW: 'aw',
  AX: 'ax',
  AZ: 'az',
  BA: 'ba',
  BB: 'bb',
  BD: 'bd',
  BE: 'be',
  BF: 'bf',
  BG: 'bg',
  BH: 'bh',
  BI: 'bi',
  BJ: 'bj',
  BL: 'bl',
  BM: 'bm',
  BN: 'bn',
  BO: 'bo',
  BQ: 'bq',
  BR: 'br',
  BS: 'bs',
  BT: 'bt',
  BV: 'bv',
  BW: 'bw',
  BY: 'by',
  BZ: 'bz',
  CA: 'ca',
  CC: 'cc',
  CD: 'cd',
  CF: 'cf',
  CG: 'cg',
  CH: 'ch',
  CI: 'ci',
  CK: 'ck',
  CL: 'cl',
  CM: 'cm',
  CN: 'cn',
  CO: 'co',
  CR: 'cr',
  CU: 'cu',
  CV: 'cv',
  CW: 'cw',
  CX: 'cx',
  CY: 'cy',
  CZ: 'cz',
  DE: 'de',
  DJ: 'dj',
  DK: 'dk',
  DM: 'dm',
  DO: 'do',
  DZ: 'dz',
  EC: 'ec',
  EE: 'ee',
  EG: 'eg',
  EH: 'eh',
  ER: 'er',
  ES: 'es',
  ET: 'et',
  FI: 'fi',
  FJ: 'fj',
  FK: 'fk',
  FM: 'fm',
  FO: 'fo',
  FR: 'fr',
  GA: 'ga',
  GB: 'gb',
  GD: 'gd',
  GE: 'ge',
  GF: 'gf',
  GG: 'gg',
  GH: 'gh',
  GI: 'gi',
  GL: 'gl',
  GM: 'gm',
  GN: 'gn',
  GP: 'gp',
  GQ: 'gq',
  GR: 'gr',
  GS: 'gs',
  GT: 'gt',
  GU: 'gu',
  GW: 'gw',
  GY: 'gy',
  HK: 'hk',
  HM: 'hm',
  HN: 'hn',
  HR: 'hr',
  HT: 'ht',
  HU: 'hu',
  ID: 'id',
  IE: 'ie',
  IL: 'il',
  IM: 'im',
  IN: 'in',
  IO: 'io',
  IQ: 'iq',
  IR: 'ir',
  IS: 'is',
  IT: 'it',
  JE: 'je',
  JM: 'jm',
  JO: 'jo',
  JP: 'jp',
  KE: 'ke',
  KG: 'kg',
  KH: 'kh',
  KI: 'ki',
  KM: 'km',
  KN: 'kn',
  KP: 'kp',
  KR: 'kr',
  KW: 'kw',
  KY: 'ky',
  KZ: 'kz',
  LA: 'la',
  LB: 'lb',
  LC: 'lc',
  LI: 'li',
  LK: 'lk',
  LR: 'lr',
  LS: 'ls',
  LT: 'lt',
  LU: 'lu',
  LV: 'lv',
  LY: 'ly',
  MA: 'ma',
  MC: 'mc',
  MD: 'md',
  ME: 'me',
  MF: 'mf',
  MG: 'mg',
  MH: 'mh',
  MK: 'mk',
  ML: 'ml',
  MM: 'mm',
  MN: 'mn',
  MO: 'mo',
  MP: 'mp',
  MQ: 'mq',
  MR: 'mr',
  MS: 'ms',
  MT: 'mt',
  MU: 'mu',
  MV: 'mv',
  MW: 'mw',
  MX: 'mx',
  MY: 'my',
  MZ: 'mz',
  NA: 'na',
  NC: 'nc',
  NE: 'ne',
  NF: 'nf',
  NG: 'ng',
  NI: 'ni',
  NL: 'nl',
  NO: 'no',
  NP: 'np',
  NR: 'nr',
  NU: 'nu',
  NZ: 'nz',
  OM: 'om',
  PA: 'pa',
  PE: 'pe',
  PF: 'pf',
  PG: 'pg',
  PH: 'ph',
  PK: 'pk',
  PL: 'pl',
  PM: 'pm',
  PN: 'pn',
  PR: 'pr',
  PS: 'ps',
  PT: 'pt',
  PW: 'pw',
  PY: 'py',
  QA: 'qa',
  RE: 're',
  RO: 'ro',
  RS: 'rs',
  RU: 'ru',
  RW: 'rw',
  SA: 'sa',
  SB: 'sb',
  SC: 'sc',
  SD: 'sd',
  SE: 'se',
  SG: 'sg',
  SH: 'sh',
  SI: 'si',
  SJ: 'sj',
  SK: 'sk',
  SL: 'sl',
  SN: 'sn',
  SO: 'so',
  SR: 'sr',
  SS: 'ss',
  ST: 'st',
  SV: 'sv',
  SX: 'sx',
  SY: 'sy',
  SZ: 'sz',
  TC: 'tc',
  TD: 'td',
  TF: 'tf',
  TG: 'tg',
  TH: 'th',
  TJ: 'tj',
  TK: 'tk',
  TL: 'tl',
  TM: 'tm',
  TN: 'tn',
  TO: 'to',
  TR: 'tr',
  TT: 'tt',
  TV: 'tv',
  TW: 'tw',
  TZ: 'tz',
  UA: 'ua',
  UG: 'ug',
  UM: 'um',
  US: 'us',
  UY: 'uy',
  UZ: 'uz',
  VA: 'va',
  VC: 'vc',
  VE: 've',
  VG: 'vg',
  VI: 'vi',
  VN: 'vn',
  VU: 'vu',
  WF: 'wf',
  WS: 'ws',
  YE: 'ye',
  YT: 'yt',
  ZA: 'za',
  ZM: 'zm',
  ZW: 'zw',
  AC: 'ac',
  CP: 'cp',
  DG: 'dg',
  EA: 'ea',
  ES_CT: 'es-ct',
  ES_GA: 'es-ga',
  EU: 'eu',
  GB_ENG: 'gb-eng',
  GB_NIR: 'gb-nir',
  GB_SCT: 'gb-sct',
  GB_WLS: 'gb-wls',
  IC: 'ic',
  TA: 'ta',
  UN: 'un',
  XK: 'xk',
});

const filterTypes = {
  BOOLEAN: 'boolean',
  STRING: 'string',
  NUMBER: 'number',
  INT_ARRAY: 'intArray',
  STRING_ARRAY: 'stringArray',
};

export {
  // eslint-disable-next-line
  componentVariants,
  buttonVariants,
  iconSizes,
  iconFlipOptions,
  iconPullOptions,
  inputTypes,
  buttonTypes,
  menuAlignOptions,
  tableCellAlignOptions,
  tooltipPositionOptions,
  tooltipMultilineOptions,
  indicatorPositionOptions,
  navigationTags,
  notificationPositionOptions,
  flagCodes,
  filterTypes,
};
